/**
 * Styles for the load-email screens. CLAUDE.md sizing rule: touch targets ≥ 56px, inputs
 * ≥ 52px, body text ≥ 16px — applied here even though older web-dispatch forms are smaller.
 */
import type * as React from 'react';

export const inputStyle: React.CSSProperties = {
  width: '100%',
  minHeight: '52px',
  padding: '10px 12px',
  fontSize: '16px',
  backgroundColor: 'var(--color-bg-tertiary)',
  border: '1px solid var(--color-border-secondary)',
  borderRadius: '10px',
  color: 'var(--color-text-primary)',
};

export const labelStyle: React.CSSProperties = {
  display: 'block',
  marginBottom: '6px',
  fontSize: '14px',
  fontWeight: 600,
  color: 'var(--color-text-secondary)',
};

export const buttonStyle: React.CSSProperties = {
  minHeight: '56px',
  padding: '0 20px',
  fontSize: '16px',
  fontWeight: 600,
  borderRadius: 'var(--radius-pill)',
  border: '1px solid var(--color-border-secondary)',
  background: 'var(--color-bg-tertiary)',
  color: 'var(--color-text-primary)',
  cursor: 'pointer',
};

export const primaryButtonStyle: React.CSSProperties = {
  ...buttonStyle,
  border: 'none',
  background: 'var(--color-accent-blue)',
  color: 'var(--color-on-accent)',
};

export const dangerButtonStyle: React.CSSProperties = {
  ...buttonStyle,
  color: 'var(--color-danger)',
};

export const cardStyle: React.CSSProperties = {
  backgroundColor: 'var(--color-bg-secondary)',
  borderRadius: 'var(--radius-card)',
  padding: '20px',
  marginBottom: '16px',
};

export const helpText: React.CSSProperties = {
  fontSize: '14px',
  color: 'var(--color-text-secondary)',
  lineHeight: 1.5,
  margin: '4px 0 0',
};

export const errorText: React.CSSProperties = {
  fontSize: '14px',
  color: 'var(--color-danger)',
  margin: '8px 0 0',
};
